import { PersistentSharedState } from '@trello/shared-state';

interface BoardSwitcherSharedState {
  isOpen: boolean;
  isSpotlightOpen: boolean;
  selectedWorkspaceId: string | null;
  expandSectionsState: Record<string, boolean>;
}

export const defaultBoardSwitcherSharedState: BoardSwitcherSharedState = {
  isOpen: false,
  isSpotlightOpen: false,
  selectedWorkspaceId: null,
  expandSectionsState: {},
};

export const boardSwitcherSharedState = new PersistentSharedState(
  defaultBoardSwitcherSharedState,
  { storageKey: 'boardSwitcherState' },
);
